import React from "react"
import { Tag } from "antd"

const PriceRequestSidebar = ({ value }) => {
  switch (value) {
    case 0:
      return <Tag color="#13c2c2">Done</Tag>
    case 1:
      return <Tag color="#fa8c16">Manager</Tag>
    case 2:
      return <Tag color="#1677ff">For Approval</Tag>
    case 3:
      return <Tag color="#f5222d">Cancelled</Tag>

    default:
      return <Tag>error</Tag>
  }
}

export default PriceRequestSidebar
